module.exports = __webpack_public_path__ + "static/media/efghij_3bhk_pent.d5f19855.jpg";